<template>
    <div class="container mt-4">
        <!-- Верхний блок с центрированием содержимого -->
        <div class="center-content" v-if="uploadedImageUrl">
            <span class="api-link">{{ uploadedImageUrl }}</span>
            <span @click="copyApiLink" class="material-symbols-outlined me-2 text-blue cursor-painter">content_copy</span>
        </div>
        <div class="center-content" v-else>
            <span class="api-link">Url...</span>
        </div>

        <form enctype="multipart/form-data">
            <div class="mb-3">
                <input type="file" id="files" class="inputfile" multiple
                       accept="image/*"
                       ref="files"
                       @change="onAttachmentChange"
                       style="display: none"
                />
                <label for="files" class="btn gray">
                    <span  class="material-symbols-outlined me-2 opacity-50">attach_file_add</span>
                    Прикрепить фотографию
                </label>
            </div>
        </form>

        <Button
            caption="Загрузить"
            icon="check"
            @click="saveRequest"
            color="green"
        />
    </div>

    <transition name="slide-fade">
        <toast-alert
            v-if="is_alert"
            @close_alert="closeAlert"
            :message="message"
            :type="type"
        />
    </transition>
</template>

<script>
import axios from "axios";
import Input from "./components/Input.vue";
import Button from "./components/Button.vue";
import ToastAlert from "./components/ToastAlert.vue";

export default {
    name: "App",
    components: {
        Input, Button, ToastAlert
    },
    data(){
        return{
            isLoggedIn: false,
            is_alert: false,
            image: null,
            files: [],
            uploadedImageUrl: null,
            message: '',
            type: 'green',
        }
    },
    created() {

    },
    methods: {
        onAttachmentChange() {
            let uploadedFiles = this.$refs.files.files;
            for( var i = 0; i < uploadedFiles.length; i++ ){
                this.files.push( uploadedFiles[i] );
            }
        },
        saveRequest() {
            // Создаем объект FormData для отправки файлов на сервер
            let formData = new FormData();
            // Добавляем каждый файл из массива files в FormData
            for (let i = 0; i < this.files.length; i++) {
                formData.append('files[]', this.files[i]);
            }

            // Отправляем POST-запрос с использованием Axios
            axios.post('/api/upload', formData)
                .then(response => {
                    // Обработка успешного ответа от сервера
                    this.message = 'Файл успешно загружен. Скопируйте ссылку';
                    this.is_alert = true;
                    setTimeout(() => {this.closeAlert(); }, 2000);
                    // Сохраняем URL загруженного изображения
                    this.uploadedImageUrl = response.data.url;
                    // Опционально: сбросить выбранные файлы после загрузки
                    this.files = [];
                })
                .catch(error => {
                    // Обработка ошибок загрузки
                    console.error('Error uploading files:', error);
                });
        },
        copyApiLink() {
            const textField = document.createElement('textarea');
            textField.innerText = this.uploadedImageUrl;
            document.body.appendChild(textField);
            textField.select();
            document.execCommand('copy');
            textField.remove();
            this.message = 'Ссылка скопирована в буфер обмена';
            this.is_alert = true;
            setTimeout(() => {this.closeAlert(); }, 1000);
        },
        closeAlert(){
            this.is_alert = false;
        },
    }
}
</script>

<style scoped>

</style>
